module.exports = __webpack_public_path__ + "img/17.0c3e6e86.jpg";